


























































































































import { Component, Vue } from 'vue-property-decorator';
import _ from 'lodash';
import { StripeIbanElement } from '@stripe/stripe-js';
import { stripeState, userState } from '@/store';
import Steps from '@/components/Steps.vue';
import FormLabel from '@/components/FormLabel.vue';

@Component({ components: { FormLabel, Steps } })
export default class PaymentMethodCreateSepaDirectDebitPage extends Vue {
  private ibanElement!: StripeIbanElement;
  private clientSecret: string = '';

  public models = {
    firstName: '',
    lastName: '',
    organizationTitle: '',
    addressStreet: '',
    addressStreetNumber: '',
    addressCity: '',
    addressZipCode: '',
    addressCountry: 'DE',
  };

  public hasIbanErrors: boolean = true;
  public isIbanElementFocused: boolean = false;

  public isConfirmingSetupIntent: boolean = false;

  public countries = _.sortBy(
    [
      { value: 'AD', label: `${this.$t('countries.AD')}` },
      { value: 'AT', label: `${this.$t('countries.AT')}` },
      { value: 'BA', label: `${this.$t('countries.BA')}` },
      { value: 'BE', label: `${this.$t('countries.BE')}` },
      { value: 'BG', label: `${this.$t('countries.BG')}` },
      { value: 'BY', label: `${this.$t('countries.BY')}` },
      { value: 'CH', label: `${this.$t('countries.CH')}` },
      { value: 'CY', label: `${this.$t('countries.CY')}` },
      { value: 'CZ', label: `${this.$t('countries.CZ')}` },
      { value: 'DE', label: `${this.$t('countries.DE')}` },
      { value: 'DK', label: `${this.$t('countries.DK')}` },
      { value: 'EE', label: `${this.$t('countries.EE')}` },
      { value: 'ES', label: `${this.$t('countries.ES')}` },
      { value: 'FI', label: `${this.$t('countries.FI')}` },
      { value: 'FR', label: `${this.$t('countries.FR')}` },
      { value: 'GB', label: `${this.$t('countries.GB')}` },
      { value: 'GR', label: `${this.$t('countries.GR')}` },
      { value: 'HR', label: `${this.$t('countries.HR')}` },
      { value: 'HU', label: `${this.$t('countries.HU')}` },
      { value: 'IE', label: `${this.$t('countries.IE')}` },
      { value: 'IS', label: `${this.$t('countries.IS')}` },
      { value: 'IT', label: `${this.$t('countries.IT')}` },
      { value: 'LI', label: `${this.$t('countries.LI')}` },
      { value: 'LT', label: `${this.$t('countries.LT')}` },
      { value: 'LU', label: `${this.$t('countries.LU')}` },
      { value: 'LV', label: `${this.$t('countries.LV')}` },
      { value: 'MC', label: `${this.$t('countries.MC')}` },
      { value: 'MD', label: `${this.$t('countries.MD')}` },
      { value: 'MT', label: `${this.$t('countries.MT')}` },
      { value: 'NL', label: `${this.$t('countries.NL')}` },
      { value: 'NO', label: `${this.$t('countries.NO')}` },
      { value: 'PL', label: `${this.$t('countries.PL')}` },
      { value: 'PT', label: `${this.$t('countries.PT')}` },
      { value: 'RO', label: `${this.$t('countries.RO')}` },
      { value: 'RS', label: `${this.$t('countries.RS')}` },
      { value: 'RU', label: `${this.$t('countries.RU')}` },
      { value: 'SE', label: `${this.$t('countries.SE')}` },
      { value: 'SK', label: `${this.$t('countries.SK')}` },
      { value: 'SM', label: `${this.$t('countries.SM')}` },
      { value: 'UA', label: `${this.$t('countries.UA')}` },
    ],
    'label',
  );

  public get buttonEnabled() {
    return (
      this.models.firstName &&
      this.models.lastName &&
      this.models.organizationTitle &&
      this.models.addressStreet &&
      this.models.addressStreetNumber &&
      this.models.addressZipCode &&
      this.models.addressCity &&
      this.models.addressCountry &&
      !this.hasIbanErrors
    );
  }

  public created() {
    document.title = `${this.$t(this.$route.meta.title)} | Comply`;
    if (!stripeState.selectedPlanId) {
      this.$router.push('/');
    }

    this.models.firstName = userState.firstName;
    this.models.lastName = userState.lastName;
    this.models.organizationTitle = userState.organization.title;
  }

  public mounted() {
    this.ibanElement = this.$stripe.elements().create('iban', {
      supportedCountries: ['SEPA'],
      style: {
        base: {
          color: '#32325d',
          fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
          fontSmoothing: 'antialiased',
          fontSize: '16px',
          '::placeholder': {
            color: '#aab7c4',
          },
        },
        invalid: {
          color: '#fa755a',
          iconColor: '#fa755a',
        },
      },
    });

    this.ibanElement.mount('#iban-element');

    this.ibanElement.on('change', this.showIbanError);
    this.ibanElement.on('focus', () => (this.isIbanElementFocused = true));
    this.ibanElement.on('blur', () => (this.isIbanElementFocused = false));
  }

  public showIbanError(event: any) {
    let displayError = document.getElementById('iban-errors');
    if (displayError) {
      if (event.error) {
        this.hasIbanErrors = true;
        displayError.textContent = event.error.message;
      } else {
        this.hasIbanErrors = false;
        displayError.textContent = '';
      }
    }
  }

  public async confirmSepaDirectDebitSetupIntent() {
    this.isConfirmingSetupIntent = true;

    try {
      const organization = await this.$api.updateOrganization({
        _id: userState.organization._id,
        organization: {
          title: this.models.organizationTitle,
          addressStreet: this.models.addressStreet,
          addressStreetNumber: this.models.addressStreetNumber,
          addressZipCode: this.models.addressZipCode,
          addressCity: this.models.addressCity,
          addressCountry: this.models.addressCountry,
        },
      });
      userState.SET_ORGANIZATION(organization);
    } catch (error) {
      console.log(error);
    }

    try {
      const { setupIntent, error } = await this.$stripe.confirmSepaDebitSetup(
        this.clientSecret,
        {
          payment_method: {
            sepa_debit: this.ibanElement,
            billing_details: {
              name: `${this.models.firstName} ${this.models.lastName}`,
              email: userState.email,
              address: {
                line1: `${this.models.addressStreet} ${this.models.addressStreetNumber}`,
                city: this.models.addressCity,
                country: this.models.addressCountry,
                postal_code: this.models.addressZipCode,
              },
            },
          },
        },
      );

      if (error) {
        // Display error.message in your UI.
        console.log(error);
        this.notification.danger({
          title: `${this.$t('labels.error')}`,
          message: `${error.message}`,
          duration: 3000,
        });
      } else if (setupIntent) {
        if (setupIntent.status === 'succeeded') {
          // The setup has succeeded. Display a success message. Send
          // setupIntent.payment_method to your server to save the card to a Customer
          if (setupIntent.payment_method) {
            const sepaDirectDebits = await this.$api.getSepaDirectDebits();
            stripeState.SET_SEPA_DIRECT_DEBITS(sepaDirectDebits);
            stripeState.SET_SELECTED_SEPA_DIRECT_DEBIT_ID(
              setupIntent.payment_method,
            );
            this.$router.push('/confirm');
          }
        }
      }
    } catch (error) {
      console.log(error);
    }

    this.isConfirmingSetupIntent = false;
  }
}
